<script setup lang="ts">
import { PAGE_LABELS } from '#shared/constants/page-labels'
import { computed } from 'vue'

import { usePageOverride } from '~/composables/useRepoApi'
import { useSimplePagePresentation } from '~/composables/useSimplePagePresentation'

const pageTitle = computed<string>(() => PAGE_LABELS.determineTransmission)

const { data: pageOverride } = await usePageOverride('opredelit-akpp')

useSimplePagePresentation({
  pageOverride,
  title: pageTitle,
  description: pageTitle,
  baseItems: computed(() => [{ name: 'Главная', slug: '/' }]),
})
</script>

<template>
  <Breadcrumbs />
  <Section>
    <TransmissionTable />
  </Section>
</template>
